export const BREAKPOINTS = {
  SMALL: 576,
  MEDIUM: 768,
  LARGE: 992,
  X_LARGE: 1200,
};

export type Breakpoint = (typeof BREAKPOINTS)[keyof typeof BREAKPOINTS];
